// lead.quotedValue is the full price history, oldest first: every Add Quote and
// every Edit Total Amount save appends an entry, and totalAmount follows the
// newest one (see appendQuotes / applyTotalAmountEdit in the backend's
// LeadController).

// Must match QUOTE_SOURCE.TOTAL_AMOUNT in ci-crm-backend/Controllers/LeadController.js.
export const QUOTE_SOURCE_TOTAL_AMOUNT = 'Total Amount';

export const isSamePrice = (a, b) => Math.abs(Number(a) - Number(b)) < 0.01;

// Newest first, each entry with its 1-based quote number and the price it replaced.
export const getQuoteHistory = (quotedValue = []) =>
    quotedValue
        .map((quote, index) => ({
            ...quote,
            quoteNumber: index + 1,
            previousPrice: index > 0 ? quotedValue[index - 1].price : undefined
        }))
        .reverse();

// The quote entry that set the current total amount, or null when the newest
// quote no longer matches it (older data where the two drifted apart).
export const getTotalAmountChange = (lead) => {
    const quotes = lead?.quotedValue || [];
    const latest = quotes[quotes.length - 1];
    return latest && isSamePrice(latest.price, lead.totalAmount) ? latest : null;
};
